// Client-side shipping ESTIMATE — mirror ของ Worker เพื่อ UX ตอน API ยังไม่ตอบ
// ค่าทางการตอน checkout มาจาก POST /api/shipping/quote เสมอ (Worker authoritative)
import { quote, chargeableGrams, freeShipEligible } from '../../shared/shipping-engine.mjs';
import { RATES, CAPS, SETTINGS, zoneOf } from '../../seed/shipping.mjs';

export function estimateOptions(items, country, subtotal) {
  const zone = zoneOf(country);
  const g = chargeableGrams(items, SETTINGS.pack_material_grams);
  const options = quote(zone, g, RATES, CAPS, SETTINGS.pack_handling_fee);
  const free = freeShipEligible(zone, subtotal, SETTINGS.free_ship_threshold);
  return { zone, options, free, source: 'estimate' };
}
